
import {Component, Vue} from 'vue-property-decorator';
import {currentUserModule, documentationModule, studyDefinitionModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import Rights = MdbsCore.Rights;

@Component({})
export default class Documentation extends Vue {
  studyDefinitionId = "";
  languageIdentifier = "";

  async mounted() {
    this.studyDefinitionId = studyDefinitionModule.studyDefinition.id;
    this.languageIdentifier = "de";
  }

  get loading() {
    return documentationModule.isLoading;
  }

  get canGetFunctionalDesign() {
    return currentUserModule.hasRight(Rights.DocumentationGetFunctionalDesignCmd);
  }

  get canGetAnnotatedEcrf() {
    return currentUserModule.hasRight(Rights.DocumentationGetAnnotatedEcrfCmd);
  }

  get canGetAnnotatedEcrfView() {
    return currentUserModule.hasRight(Rights.DocumentationGetAnnotatedEcrfViewCmd);
  }

  get canGetCompleteDocumentation() {
    return currentUserModule.hasRight(Rights.DocumentationGetCompleteCmd);
  }

  async getFunctionalDesign() {
    await documentationModule.getFunctionalDesign({
      studyDefinitionId: this.studyDefinitionId,
      languageIdentifier: this.languageIdentifier
    })
        .then(response => {
          if (response && response.data) {
            this.startDownload(
                response.data,
                response.fileName ??
                studyDefinitionModule.studyDefinition.identifier + "_FunctionalDesign_" + studyDefinitionModule.studyDefinition.version + ".xlsx");
          }
        }).catch(console.error)
  }

  async getAnnotatedEcrf() {
    await documentationModule.getAnnotatedEcrf({
      studyDefinitionId: this.studyDefinitionId,
      languageIdentifier: this.languageIdentifier
    })
        .then(response => {
          if (response && response.data) {
            this.startDownload(response.data,
                response.fileName ??
                studyDefinitionModule.studyDefinition.identifier + "_AnnotatedECRF_" + studyDefinitionModule.studyDefinition.version + ".pdf");
          }
        }).catch(console.error)
  }

  async getAnnotatedEcrfView() {
    await documentationModule.getAnnotatedEcrfView({
      studyDefinitionId: this.studyDefinitionId,
      languageIdentifier: this.languageIdentifier
    })
        .then(response => {
          if (response) {
            let newWindow = window.open();
            newWindow?.document.write(response);
          }
        }).catch(console.error)
  }

  async getCompleteDocumentation() {
    await documentationModule.getCompleteDocumentation({
      studyDefinitionId: this.studyDefinitionId,
      languageIdentifier: this.languageIdentifier
    })
        .then(response => {
          if (response && response.data) {
            this.startDownload(
                response.data,
                response.fileName ??
                studyDefinitionModule.studyDefinition.identifier + "_Documentation_" + studyDefinitionModule.studyDefinition.version + ".zip");
          }
        }).catch(console.error)
  }


  private startDownload(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


}
